// extracted by mini-css-extract-plugin
module.exports = {"container":"WorkflowPreview_container_3AvDe","workflow":"WorkflowPreview_workflow_35pI7","show":"WorkflowPreview_show_3j1tG","openNDV":"WorkflowPreview_openNDV_234_d"};